module.exports = __webpack_public_path__ + "static/media/swpic.2a288a92.png";